// P0: HSQ page-scope configuration. Loaded from a JSON file in webapp/specs/
// so the visible page list can be trimmed or expanded without touching code.
// Three exports:
//   - HSQ_PAGE_INDICES — every page (by `pageOrder`/`index`) the webapp should
//     KNOW about. Tooltip-only pages are included here so tooltip-popover
//     fetches still resolve.
//   - HSQ_LANDING_FOLDER — folder slug the "/" route redirects to.
//   - TOOLTIP_ONLY_INDICES — subset that should be reachable for tooltip
//     fetches but hidden from the side nav.

import cfg from "../../../specs/_hsq_pages.json";

const _cfg = cfg as {
  pageIndices: number[];
  landingFolder: string;
  tooltipOnly: number[];
};

export const HSQ_PAGE_INDICES: ReadonlySet<number> = new Set<number>(_cfg.pageIndices);
export const HSQ_LANDING_FOLDER: string = _cfg.landingFolder;
export const TOOLTIP_ONLY_INDICES: ReadonlySet<number> = new Set<number>(_cfg.tooltipOnly);
